// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"126":"d4e5e4f89cb883b5","888":"0c01cf71a20ad6e6"}[chunkId] + ".css";
};